export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('form_label_salesChannel') || '销售渠道',
    field: 'salesChannel',
    minWidth: 170,
    align: 'center',
  },
  {
    title: that.$l('form_label_orderNo') || '渠道订单编号',
    field: 'orderNo',
    minWidth: 150,
    align: 'center',
  },
  {
    title: that.$l('form_label_customerOrderNo') || '客户订单编号',
    field: 'customerOrderNo',
    minWidth: 150,
    align: 'center',
  },
  {
    title: that.$l('form_label_orderStatus') || '状态',
    field: 'orderStatus',
    minWidth: 100,
    align: 'center',
    slots: { default: 'status' },
  },
  {
    title: that.$l('form_label_shippingOrderStatus') || '发货单状态',
    field: 'shippingOrderStatus',
    minWidth: 100,
    align: 'center',
    slots: { default: 'shippingOrderStatus' },
  },
  {
    title: that.$l('form_label_orderDate') || '订单时间',
    field: 'v_orderDate',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('form_label_amount') || '订单金额',
    field: 'v_amount',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('form_label_estimatedShipDate') || '预计发货日期',
    field: 'v_estimatedShipDate',
    minWidth: 120,
    align: 'center',
  },
  {
    title: that.$l('form_label_estimatedDeliveryDate') || '预计到货日期',
    field: 'v_estimatedDeliveryDate',
    minWidth: 120,
    align: 'center',
  },
  {
    title: that.$l('form_label_shippingMethod') || '配送方式',
    field: 'shippingMethod',
    minWidth: 200,
    align: 'left',
    slots: { default: 'shippingMethod' },
  },
  {
    title: that.$l('form_label_contact') || '联系人/电话',
    field: 'contact',
    minWidth: 170,
    align: 'left',
    slots: { default: 'contact' },
  },
  {
    title: that.$l('form_label_address') || '收货地址',
    field: 'address',
    minWidth: 250,
    align: 'left',
    slots: { default: 'address' },
  },
  {
    title: that.$l('form_label_createType') || '创建方式',
    field: 'v_createType',
    minWidth: 100,
    align: 'center',
  },
  {
    title: that.$l('INDEX.create_date') || '创建时间',
    field: 'v_createTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
  },
  {
    title: that.$l('INDEX.table_label_modification_time') || '修改时间',
    field: 'v_modifyTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
  },
]
